const ADDRESS_API = 'https://api.getAddress.io/find';
const byPostcode = async (query, api_key) => {
    const addressData = await fetch(`${ADDRESS_API}/${query}?api-key=${api_key}&expand=true&sort=true`).then((response) => response.json());
    return addressData;
};
export default { byPostcode };
